import debounce from 'lodash/debounce';
import {useCallback, useEffect, useRef} from 'react';

import {useIsMounted} from './useIsMounted';

export const useDebounce = (cb: (...args: any) => void, delay = 500) => {
  const isMounted = useIsMounted();

  const inputsRef = useRef({cb, delay});

  useEffect(() => {
    inputsRef.current = {cb, delay};
  }, [cb, delay]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    debounce((...args) => {
      // Debounce is an async callback. Cancel it, if in the meanwhile
      // (1) component has been unmounted (see isMounted in snippet)
      // (2) delay has changed
      if (inputsRef.current.delay === delay && isMounted()) inputsRef.current.cb(...args);
    }, delay),
    [cb, delay]
  );
};
